var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "payment" } },
    [
      _c("payment-header", {
        attrs: {
          "page-component": _vm.pageComponent,
          "prev-route": _vm.prevRoute,
        },
      }),
      _c(_vm.pageComponent, {
        tag: "component",
        attrs: { data: _vm.data },
        on: {
          "next-component": _vm.activeComponent,
          "step-back": _vm.stepBack,
        },
      }),
      _c("dialog-expired-free-trial", {
        attrs: { visible: _vm.dialogExpiredFreeTrial },
        on: {
          close: function ($event) {
            _vm.dialogExpiredFreeTrial = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }